const CMS = () => {
    return <div>Backoffice / Content Management System (CMS)</div>
}

export default CMS
